import React from 'react';
import { useAuthenticationContext } from '../hooks/useAuthenticationContext';
import { Navigate } from 'react-router-dom';

export interface IRequireAuthProps {
    redirectTo: string;
}

export const RequireAuth: React.FunctionComponent<IRequireAuthProps> = (props: React.PropsWithChildren<IRequireAuthProps>) => {
    const { user, isCheckingAuth } = useAuthenticationContext();

    if(isCheckingAuth) return <></>

    if (!user) {
        // Preserve the current location (pathname + search) as the return URL
        const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
        const redirectPath = `${props.redirectTo}?returnUrl=${returnUrl}`;
        return <Navigate to={redirectPath} />;
    }

    return <>{props.children}</>;
}

export default RequireAuth;